var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 62,
    viewBox: "0 0 108 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52246",
    "data-name": "Group 52246",
    transform: "translate(-257 -359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52237",
    "data-name": "Group 52237",
    transform: "translate(16742 1255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52235",
    "data-name": "Group 52235",
    transform: "translate(-19 -141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9376",
    "data-name": "Rectangle 9376",
    transform: "translate(-16466 -755)",
    fill: "#fff",
    stroke: "#b2b2bf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 107.5,
    height: 61.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9372",
    "data-name": "Rectangle 9372",
    transform: "translate(-16458 -747)",
    fill: "#d1d6dd",
    stroke: "#d1d6dd",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 90.5,
    height: 46.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_52839",
    "data-name": "Path 52839",
    transform: "translate(-16455 -888)",
    fill: "#d1d6dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47.5 46.5 L 0.5 46.5 L 0.5 0.5 L 47.5 0.5 L 47.5 46.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 1 46 L 47 46 L 47 1 L 1 1 M 0 0 L 48 0 L 48 47 L 0 47 L 0 0 Z",
    stroke: "none",
    fill: "#d1d6dd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-image",
    "data-name": "Icon metro-image",
    d: "M35.667,6.063l0,0V32.539l0,0H4.781l0,0V6.067l0,0Zm0-2.207H4.777A2.213,2.213,0,0,0,2.571,6.063v26.48a2.213,2.213,0,0,0,2.207,2.207H35.671a2.213,2.213,0,0,0,2.207-2.207V6.063a2.213,2.213,0,0,0-2.207-2.207Zm-4.413,7.723a3.31,3.31,0,1,1-3.31-3.31,3.31,3.31,0,0,1,3.31,3.31Zm2.207,18.757H6.984V25.923l7.723-13.24,8.827,11.033h2.207l7.723-6.62Z",
    transform: "translate(290.43 371.144)",
    fill: "#f1f1f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImage);
export default __webpack_public_path__ + "static/media/BackgroundImage.cf4492862f80e5f7ee553e250a7970cb.svg";
export { ForwardRef as ReactComponent };